import React, { useState } from 'react';
import css from './AdminPageSuperDeals.css';
import EditForm from './EditForm';
import { SectionSuperDeals } from '../LandingPage/sectionsSuperDeals';
import AdminHOC from '../AdminPanelsPage/AdminHOC';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import AdminActionsNav from '../AdminPanelsPage/AdminActionsNav';
import { changeDateToEndOfDay } from '../AdminPanelsPage/changeDateToEndOfDay';

const Panel = ({
    currentUser,
    showList,
    handleAdminAction: handleAdminActionParent,
    handleSubmit: handleSubmitParent,
    goBack,
    showForm,
    initialValues,
    action,
    history,
}) => {
    const [showOutdated, setShowOutdated] = useState(false);

    const handleSubmit = values => {
        const endOfDayDate = new Date(values.endDate.date);
        changeDateToEndOfDay(endOfDayDate);

        handleSubmitParent({
            ...values,
            endDate: {
                date: endOfDayDate,
            },
        });
    };

    const handleAdminAction = (action, initialValues) => {
        const isEdit = action === 'edit';
        const endDateMaybe = initialValues && initialValues.endDate && initialValues.endDate.date;
        const values =
            isEdit && endDateMaybe
                ? {
                      ...initialValues,
                      endDate: {
                          date: new Date(initialValues.endDate.date),
                      },
                  }
                : initialValues;

        handleAdminActionParent(action, values);
    };

    return (
        <>
            <AdminActionsNav
                showOutdated={showOutdated}
                handleAdding={() => handleAdminActionParent('add')}
                handleShowingOutdated={() => setShowOutdated(prevState => !prevState)}
                handleWatchList={() =>
                    history.push(createResourceLocatorString('SuperDeals', routeConfiguration()))
                }
            />
            {showList && (
                <SectionSuperDeals
                    handleAdminAction={handleAdminAction}
                    currentUser={currentUser}
                    showOutdated={showOutdated}
                />
            )}
            {showForm && (
                <p type="button" onClick={goBack} className={css.backButton}>
                    Zurück
                </p>
            )}
            {showForm && (
                <EditForm onSubmit={handleSubmit} initialValues={initialValues} action={action} />
            )}
        </>
    );
};

export default AdminHOC(Panel);
